import SampleColorCard from "../../components/Card/SampleColorCard";
import Restricted from "../../context/Restricted";
import { Link, useNavigate } from "react-router-dom";
import ImageSlider from "../../components/ImageSlider";
import ImageCard from "../../components/Card/ImageCard";
import Input from "../../components/Input";
import Plan2Form from "../AdvPanel/Plan2Form";
import FormHeader from "../../components/Other/FormHeader";
import { isApp } from "../../utils/helper";



export default function ContactUs() {
    const navigate = useNavigate();
    const apiUrl = process.env.REACT_APP_URL_KEY;
    const handleHref = (service) => {
        if (isApp()) {
            window.open(`${apiUrl}redirectApp?service=${service}`)
        } else {
            if (service === "rubika") {
                window.location.href = "https://rubika.ir/karsood";
            } else if (service === "rubika_support") {
                window.location.href = "https://rubika.ir/Karsoodsupport";
            } else if (service === "rubika_edu") {
                window.location.href = "https://rubika.ir/amoozeshapp";
            } else if (service === "eitaa") {
                window.location.href = "https://eitaa.com/joinchat/1355154144C039099a07d";
            } else if (service === "eitaa_support") {
                window.location.href = "https://eitaa.com/Karsoodsupport";
            } else if (service === "eitaa_edu") {
                window.location.href = "https://eitaa.com/amoozeshapp";
            } else if (service === "telegram") {
                window.location.href = "https://t.me/ikarsood";
            } else if (service === "telegram_support") {
                window.location.href = "https://t.me/Karsoodsupport";
            } else if (service === "telegram_edu") {
                window.location.href = "https://t.me/iamoozeshapp";
            }
        }
    }
    return (
        <>
            <div className={`mb-2 card formBorderBox text-white bg-light-gray p-2 prl-10 mb-2`}>
                <div className={"col-12 text-center  font-11 pb-2"}>
                    <div className={" borderRadius5 text-white p-2 font-11"}>
                        <img src="/images/support.png" className={"w-px-200 me-2"} />
                    </div>
                </div>
                <a href={"tel:05191099395"} tabIndex="_blank"
                    className={"col-12 text-center cursor-pointer font-11 pb-4"}>
                    <span
                        className={'direction-rtl text-center font-22 color-white '}> تلفن پشتیبانی : 91099395-051</span>
                </a>
                <div className="row ">
                    <div onClick={() => handleHref("eitaa_support")}
                        className={"col-6 text-center cursor-pointer font-11 pb-2"}>
                        <div className={"bg-info borderRadius5 text-white p-2"}>
                            <img src="/images/eita.png" className={"w-px-30 me-2"} />
                            پشتیبانی ایتا
                        </div>
                    </div>
                    <div onClick={() => { handleHref("rubika_support") }}
                        className={"col-6 text-center cursor-pointer font-11 pb-2"}>
                        <div className={"bg-dribbble borderRadius5 text-white p-2 font-11"}>
                            <img src="/images/rubika.png" className={"w-px-30 me-2"} />
                            پشتیبانی روبیکا
                        </div>
                    </div>
                    <div onClick={() => handleHref("telegram_support")}
                        className={"col-12 text-center cursor-pointer font-11 pb-2 centered"}>
                        <div className={"bg-primary borderRadius5 text-white p-2"}>
                            <img src="/images/telegram.png" className={"w-px-30 me-2"} />
                            پشتیبانی تلگرام
                        </div>
                    </div>
                </div>
            </div>

            <div className={`mb-2 card formBorderBox text-white bg-light-gray p-2 prl-10 mb-2`}>
                <p className={"text-center "}>کانال های آموزش کار با کارسود</p>
                <p className={"text-center "}>
                    برای اینکه کار با قسمت‌های مختلف کارسود را یاد بگیرید و راحت‌تر بتوانید کسب درآمد کنید، حتما در یکی
                    از کانال‌های آموزشی زیر عضو شوید
                </p>
                <div className="row">
                    <div className={"borderRadius5 text-white p-2 font-11 text-center d-flex-center"}>
                        <div onClick={() => { handleHref("eitaa_edu") }}
                            className={"text-center cursor-pointer "}>
                            <img src="/images/eita.png" className={"w-px-50"} />
                        </div>

                        <div onClick={() => { handleHref("rubika_edu") }}
                            className={"text-center cursor-pointer "}>
                            <img src="/images/rubika.png" className={"w-px-50"} />
                        </div>

                        <div onClick={() => { handleHref("telegram_edu") }}
                            className={"text-center cursor-pointer "}>
                            <img src="/images/telegram.png" className={"w-px-50"} />
                        </div>
                    </div>
                </div>
            </div>
            <div className={`mb-2 card formBorderBox text-white bg-light-gray p-2 prl-10 mb-2`}>
                <p className={"text-center "}>شبکه های اجتماعی و اطلاع رسانی کارسود</p>
                <p className={"text-center "}>
                    برای اینکه به موقع از اخبار و اطلاعیه‌های کارسود با خبر بشید، حتماً در یکی از کانالهای زیر عضو بشید
                </p>
                <div className="row ">

                    <div className={"borderRadius5 text-white p-2 font-11 text-center d-flex-center"}>
                        <div onClick={() => { handleHref("eitaa") }}
                            className={"text-center cursor-pointer "}>
                            <img src="/images/eita.png" className={"w-px-50"} />
                        </div>
                        <div onClick={() => { handleHref("rubika") }}
                            className={"text-center cursor-pointer "}>
                            <img src="/images/rubika.png" className={"w-px-50"} />
                        </div>
                        <div onClick={() => handleHref("telegram")}
                            className={"text-center cursor-pointer "}>
                            <img src="/images/telegram.png" className={"w-px-50"} />
                        </div>
                    </div>


                </div>
            </div>

        </>
    )
}